import { useState, useEffect, useRef } from 'react'
import styles from './BadgeTemplateManager.module.css'
import { useNavigate, useLocation, Link } from 'react-router-dom'

// ------ Services ------ //
import * as clientEventService from '../../../services/clientEventService'

const BadgeTemplateManager = () => {
    const navigate = useNavigate()
	const location = useLocation()
    const passedState = location.state
    // useLocation & useNavigate --- Client state from previous page
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current =passedData
        }
       
    }
    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])

    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }

    }, [])
	return (
        <div id={styles.eventConfigurePage}>
            <h1>Event Badges Template Management</h1><br />
            <h2>Controls badge template layout and printing. </h2><br />
            <div id={styles.eventConfigureContainer}>
                <Link to={`/RegTypeMapping`} state={clientEventInfo} className={styles.eventLinks} title="Event registrants mapping.">
                    <h3>Registration Type Mapping</h3>
                </Link>
                <Link to={`/BadgeScannerImageManager`} state={clientEventInfo} className={styles.eventLinks} title="Barcode/QRCode property management.">
                    <h3>Scanner Image Logic</h3>
                </Link>
                <Link to={`/BadgeTemplateFieldOrdering`} state={clientEventInfo} className={styles.eventLinks} title="Badge template field layout ordering.">
                    <h3>Badge Template Field Ordering Manager</h3>
                </Link>
                <Link to={`/MainBadgeTemplateStyling`} state={clientEventInfo} className={styles.eventLinks} title="Create/edit badge templates - style editing.">
                    <h3>Template/Styling Manager</h3>
                </Link>
                <Link to={`/BadgeImageManager`} className={styles.eventLinks} title="Image handler for all badges.">
                    <h3>Badge Image Manager</h3>
                </Link>
            </div>

            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
        </div>
    );
}

export default BadgeTemplateManager;